import React, { useEffect, useMemo, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import Modal from "react-bootstrap/Modal";
import "./Layoutview.css";

const PopUpcarosal = ({
  handleClosepopupcaro,
  layoutNameSelect,
  data,
  show,
}) => {
  const [index, setIndex] = useState(0);
  const [isBeforeRenderRun, setIsBeforeRenderRun] = useState(false);

  if (!isBeforeRenderRun) {
    window.addEventListener("error", (e) => {
      if (e) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr)
          resizeObserverErr.className = "hide-resize-observer";
        if (resizeObserverErrDiv)
          resizeObserverErrDiv.className = "hide-resize-observer";
      }
    });
    setIsBeforeRenderRun(true);
  }

  useEffect(() => {
    return () => setIsBeforeRenderRun(false);
  }, []);

  const libraryIds = useMemo(() => {
    return data && data.libraryIds ? JSON.parse(data.libraryIds) : [];
  }, [data]);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    if (libraryIds.length === 0) return;

    const interval = setInterval(() => {
      setIndex((prevIndex) =>
        prevIndex === libraryIds.length - 1 ? 0 : prevIndex + 1
      );
    }, libraryIds[index]?.duration * 1000 || 5000);

    return () => clearInterval(interval);
  }, [index, libraryIds]);

  const renderMediaContent = (library) => {
    if (library.mediaType === "image") {
      return (
        <img
          src={library.fileUrl}
          alt="Ima//"
          className="img-fluid"
          style={{ width: "65%" }}
        />
      );
    } else if (library.mediaType === "video") {
      return (
        <video autoPlay controls className="carousel-item-video">
          <source src={library.fileUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }
    return null;
  };

  return (
    <div>
      <Modal
        show={show}
        onHide={handleClosepopupcaro}
        size="lg"
        fullscreen
        className="custom-modal-display"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Layout - {layoutNameSelect}</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {libraryIds.length > 0 ? (
            <Carousel activeIndex={index} onSelect={handleSelect}>
              {libraryIds.map((library, index) => (
                <Carousel.Item key={index} className="media-content">
                  {renderMediaContent(library)}
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <h6 className="text-center">
              Please Upload files to view layout display.
            </h6>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PopUpcarosal;
